import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { type StackItemBase } from '../data/portfolioData';

interface TechMarqueeProps {
  stacks: StackItemBase[];
  selectedStackId: string;
  onSelectStackId: (id: string) => void;
}

export const TechMarquee: React.FC<TechMarqueeProps> = ({
  stacks,
  selectedStackId,
  onSelectStackId,
}) => {
  const { t } = useTranslation();

  return (
    <section className="py-12 border-b border-gray-800/80 overflow-hidden">
      <div className="flex justify-between items-center mb-6 font-mono text-xs">
        <span className="text-gray-500">{t('marquee.headline')}</span>
        <span className="text-[#00F0FF] flex items-center space-x-1">
          <Sparkles size={12} />
          <span>{t('marquee.badge')}</span>
        </span>
      </div>

      {/* Marquee Wrapper */}
      <div className="relative w-full overflow-hidden bg-[#0A0D14] border-y border-[#00F0FF]/20 py-4 group">

        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-16 z-10 bg-linear-to-r from-[#07090E] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 z-10 bg-linear-to-l from-[#07090E] to-transparent pointer-events-none" />

        {/* Marquee Track */}
        <div className="flex space-x-8 animate-marquee group-hover:[animation-play-state:paused] whitespace-nowrap font-mono text-lg sm:text-2xl font-bold tracking-wider">
          {[...stacks, ...stacks, ...stacks].map((item, idx) => {
            const isSelected = selectedStackId === item.id;
            return (
              <button
                key={`${item.id}-${idx}`}
                type="button"
                onClick={() => onSelectStackId(item.id)}
                className={`inline-flex items-center space-x-4 transition-all duration-300 px-3 py-1 cursor-pointer hover:scale-105 ${
                  isSelected
                    ? 'text-[#00F0FF] drop-shadow-[0_0_12px_rgba(0,240,255,0.8)] bg-[#00F0FF]/10 border border-[#00F0FF]/40'
                    : 'text-gray-400 hover:text-[#00F0FF]'
                }`}
              >
                <span>{item.name}</span>
                <span className="text-[#00F0FF]/40 text-sm">//</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
